<template>
  <section class="sec-graphs">

    <div class="tab">
      <div class="container-fluid pl-0 pr-0">
        <ul class="nav nav-tabs row ml-0 mr-0">
          <li
            class="col-xs-6 pl-0 pr-0 heatmap clickable"
            :class="selection == 'heat-map' ? 'selected active': 'unselected'"
          >
            <a
              class="clearfix"
              v-on:click="selectOption('heat-map')"
            >
              <span
                :class="selection == 'heat-map' ? 'selected-text': 'unselected-text'"
                class="tab-label"
              >
                Heatmap
                <i class="icon icon-glob-light"></i>
              </span>
            </a>
          </li>
          <li
            class="col-xs-6  pl-0 pr-0 data clickable"
            :class="selection == 'data' ? 'selected-data active': 'unselected'"
          >
            <a
              class="clearfix"
              v-on:click="selectOption('data')"
            >
              <span
                :class="selection == 'data' ? 'selected-text': 'unselected-text'"
                class="tab-label"
              >
                Data
                <i class="icon icon-level-light"></i>
                <i class="icon icon-level-circle-light"></i>
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'chart-view-selector',
  data() {
    return {
      selection: 'heat-map'
    };
  },
  methods: {
    selectOption(value){
      this.$emit('chart-selection', value)
      this.selection = value
    }
  }
}

</script>

<style scoped>

.clickable {
  cursor: pointer;
}

.unselected {
  background: #30353B;
  opacity: 1;
}

.unselected-text {
  color: white;
  opacity: 1;
}

.selected {
  background: white;
  opacity: 1;
}

.selected-data {
  background: #F7F7F7;
  opacity: 1;
}

.selected-text {
  color: black;
  opacity: 1;
}

</style>



// WEBPACK FOOTER //
// src/elements/ChartViewSelection.vue